import React__default from 'react';
import { Tooltip } from 'antd';

var DmNameDescription = function DmNameDescription(_ref) {
  var name = _ref.name,
    description = _ref.description,
    size = _ref.size,
    inverse = _ref.inverse,
    showTooltip = _ref.showTooltip,
    style = _ref.style,
    firstTextStyles = _ref.firstTextStyles,
    secondTextStyles = _ref.secondTextStyles,
    className = _ref.className;
  var nameRowClass = size ? size === 'x-small' ? 'dm-name-description-x-small-name-row' : size === 'small' ? 'dm-name-description-small-name-row' : size === 'large' ? 'dm-name-description-large-name-row' : 'dm-name-description-medium-name-row' : 'dm-name-description-medium-name-row';
  var descriptionRowClass = size ? size === 'x-small' ? 'dm-name-description-x-small-description-row' : size === 'small' ? 'dm-name-description-small-description-row' : size === 'large' ? 'dm-name-description-large-description-row' : 'dm-name-description-medium-description-row' : 'dm-name-description-medium-description-row';
  return showTooltip ? /*#__PURE__*/React__default.createElement("div", {
    className: "dm-name-description-col ".concat(className),
    style: style
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    placement: "top",
    title: description,
    color: "rgba(20, 3, 53, 0.8)",
    overlayClassName: "custom-tooltip-inner"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: firstTextStyles,
    className: inverse ? descriptionRowClass : nameRowClass
  }, name), /*#__PURE__*/React__default.createElement("div", {
    style: secondTextStyles,
    className: inverse ? nameRowClass : descriptionRowClass
  }, description))) : /*#__PURE__*/React__default.createElement("div", {
    className: "dm-name-description-col ".concat(className),
    style: style
  }, /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: inverse ? descriptionRowClass : nameRowClass
  }, name), /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: inverse ? nameRowClass : descriptionRowClass
  }, description));
};
DmNameDescription.defaultProps = {
  name: undefined,
  description: undefined,
  size: 'large',
  inverse: false,
  showTooltip: false,
  className: undefined,
  style: undefined,
  firstTextStyles: undefined,
  secondTextStyles: undefined
};

export { DmNameDescription };
